import React from 'react';
import t from 'rcm-i18n';

interface Props {
    order: any;
}

const orderContainsPwsItem = (order) => {
    return typeof order.conditions.find(
        (condition) => condition.name === 'order-contains-pws-item'
    ) !== 'undefined';
};

const ReceiptPwsSetupLink = ({ order }: Props) => {
    return <>
        {orderContainsPwsItem(order) &&
            <div className="panel panel-primary">
                <div className="panel-body">
                    <a href="/pws">{t('Click here to setup your new personal website.')}</a>
                </div>
            </div>
        }
    </>;
};

export default ReceiptPwsSetupLink;
